import * as AnalyticAppColor from 'common/constants/analytic-app-color';

// TODO get from template
// Create AnalyticsLayerEnum but exclude colors.
// Match colors in a JS util, as cards do?

export const DEGREE_DAYS = {
  color: AnalyticAppColor.GRAY,
  displayName: 'Degree Days',
  id: Number.MIN_VALUE,
  slug: 'degreeDays',
};
export const NONE = {
  color: AnalyticAppColor.GRAY,
  displayName: 'None',
  id: 0,
  slug: 'none',
};
export const PREVIOUS_PERIOD = {
  color: AnalyticAppColor.GRAY,
  displayName: 'Previous Period',
  id: 1,
  slug: 'previous',
};
export const TEMPERATURE = {
  color: AnalyticAppColor.LAVENDER,
  displayName: 'Outdoor Temperature',
  id: 2,
  slug: 'temperature',
};
export const FORECAST = {
  color: AnalyticAppColor.BLUE,
  displayName: 'Forecast',
  id: 3,
  slug: 'forecast',
};
export const COOLING_DEGREE_DAYS = {
  color: AnalyticAppColor.LIGHT_BLUE,
  displayName: 'Cooling Degree Days',
  id: 5,
  slug: 'coolingDegreeDays',
};
export const HEATING_DEGREE_DAYS = {
  color: AnalyticAppColor.PAPAYA,
  displayName: 'Heating Degree Days',
  id: 6,
  slug: 'heatingDegreeDays',
};
export const SAME_DAY_LAST_WEEK = {
  color: AnalyticAppColor.GRAY,
  displayName: 'Same Day Last Week',
  id: 7,
  slug: 'last',
};
export const BASELOAD = {
  color: AnalyticAppColor.GRAY,
  displayName: 'Baseload',
  id: 8,
  slug: 'baseload',
};
export const PEAK = {
  color: AnalyticAppColor.GRAY,
  displayName: 'Peak demand',
  id: 9,
  slug: 'peak',
};
export const CUSTOM_RANGE = {
  color: AnalyticAppColor.BLUE,
  displayName: 'Custom period',
  id: 10,
  slug: 'customRange',
};
export const BASELINE = {
  color: AnalyticAppColor.BLUE,
  displayName: undefined,
  id: undefined,
  slug: 'baseline',
};
